import React from 'react'
import MapPin from 'src/components/icons/ui/MapPin'
import { ISavedLocations } from 'src/types'

interface ISavedLocationItemProps {
  location: ISavedLocations
  handleSelectRecentLocation: (location: ISavedLocations) => void
}

const SavedLocationItem = ({ location, handleSelectRecentLocation }: ISavedLocationItemProps) => (
  <div
    className='b-rad-8 cursor--pointer flex items-center rp-mt8 rp-p12 rp-recent-locations-item'
    role='button'
    tabIndex={0}
    onClick={() => handleSelectRecentLocation(location)}
    onKeyDown={e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        handleSelectRecentLocation(location)
      }
    }}
  >
    <div className='rp-locations-icon-wrapper'>
      <MapPin className='icon--16x16 rp-mr8 svg-color-green1' />
    </div>
    <p className='font-black1 rp-m0 text-sm'>{location.fullAddress}</p>
  </div>
)

export default SavedLocationItem



// WEBPACK FOOTER //
// ./src/components/riders/rider-portal/trips/create/Step1/SavedLocationItem.tsx